import { render, staticRenderFns } from "./FormHeaderVariant.vue?vue&type=template&id=24ea7ef4&scoped=true&"
import script from "./FormHeaderVariant.vue?vue&type=script&lang=js&"
export * from "./FormHeaderVariant.vue?vue&type=script&lang=js&"
import style0 from "./FormHeaderVariant.vue?vue&type=style&index=0&id=24ea7ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ea7ef4",
  null
  
)

export default component.exports